/**
 * @desc sku报价停用
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.Response;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/supplierQuotationDisable/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
